// extracted by mini-css-extract-plugin
export default {"redirectingLabel":"styles__redirectingLabel___DY9cj"};